module.exports = `${require.publicPath}sby-logo-dark.58d41e1c.png`;